import React from 'react';
import { plural } from './util';
import './search.css';

const dropText = (e) => (e.kind === 'seq' ? 'Unlink ' : 'Drop ') + e.label + ': ' + plural(e.n, 'show');

// Live match count ("24 shows"). At zero it offers up to 3 one-step
// recoveries from the server's dropOne list: "Drop <label>: <n> shows"
// ("Unlink" for an into-run). onDrop(entry) gets the B.3 dropOne element.
// Optional (additive): `error` text shown when the count could not be fetched;
// `suggestionsOnly` hides the pill (for an empty state that already says
// "No shows match all of these").
export default function CountPill({ count, loading, onDrop, error, suggestionsOnly }) {
  const n = count && typeof count.n === 'number' ? count.n : null;
  const drops =
    n === 0 && count && Array.isArray(count.dropOne)
      ? count.dropOne.filter((e) => e && e.kind && e.label && e.n > 0).slice(0, 3)
      : [];
  let text = '';
  if (n != null) text = n === 0 ? 'No shows' : plural(n, 'show');
  else if (loading) text = 'Counting...';
  else if (error) text = 'Count unavailable';
  if (!text || (suggestionsOnly && !drops.length)) return null;
  return (
    <div className={'ss-count' + (suggestionsOnly ? ' only' : '')}>
      {!suggestionsOnly && (
        <span
          className={'ss-pill' + (n === 0 ? ' zero' : '') + (loading ? ' busy' : '') + (n == null && error ? ' err' : '')}
          role="status"
          aria-live="polite"
          title={n == null && error ? error : undefined}
        >
          {loading && <span className="spinner ss-spin" aria-hidden="true" />}
          <span>{text}</span>
        </span>
      )}
      {drops.length > 0 && (
        <div className="ss-drops">
          <div className="ss-drops-head">One change finds shows:</div>
          {drops.map((e) => (
            <button key={e.kind + ':' + e.value} type="button" className="ss-drop" onClick={() => onDrop && onDrop(e)}>
              {dropText(e)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
